import { render, staticRenderFns } from "./LeftAsides.vue?vue&type=template&id=06c71898&scoped=true&"
import script from "./LeftAsides.vue?vue&type=script&lang=js&"
export * from "./LeftAsides.vue?vue&type=script&lang=js&"
import style0 from "./LeftAsides.vue?vue&type=style&index=0&id=06c71898&lang=scss&scoped=true&"
import style1 from "./LeftAsides.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c71898",
  null
  
)

export default component.exports